import UserVerdict from './UserVerdict'

export default UserVerdict
